import {MachineType} from '@domain/machine/machine-type.enum';

export enum YieldUnit {
  STITCHES,
  PICKS,
  CARPETS,
  METER
}

export namespace YieldUnit {
  const machineTypesWithYieldUnit: Map<MachineType, YieldUnit> = new Map<MachineType, YieldUnit>([
    [MachineType.CARPET_LOOM, YieldUnit.PICKS],
    [MachineType.CARPET_LOOM_NO_JQ, YieldUnit.PICKS],
    [MachineType.COLORTEC, YieldUnit.STITCHES],
    [MachineType.COLORTECLPLUS, YieldUnit.STITCHES],
    [MachineType.MYRIAD, YieldUnit.STITCHES],
    [MachineType.TUFT, YieldUnit.METER],
    [MachineType.VELVET, YieldUnit.PICKS],
    [MachineType.VELVET_NO_JQ, YieldUnit.PICKS],
    [MachineType.JACQUARD, YieldUnit.PICKS],
    [MachineType.SUPERBADYE, YieldUnit.METER],
    [MachineType.SUPERBAHEAT, YieldUnit.METER],
    [MachineType.SUPERBAWINDER, YieldUnit.METER],
    [MachineType.FINISHING, YieldUnit.CARPETS],
    [MachineType.WEAVING_MACHINE, YieldUnit.METER]
  ]);

  export function getYieldUnitForMachineType(machineType: MachineType): YieldUnit {
    return machineTypesWithYieldUnit.get(machineType);
  }
}
